import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Table, Button, Typography, Select, Row, Col, Image } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import AbroadInsuranceFormModal from "./components/abroadInsuranceFormModal";
import ActionsColumn from "./components/ActionColumn";
import AdvancedSearchForm from "../../../common/SearchForm";
import { DEFAULT_AGENCY_IMAGE } from "../../../common/awsBucket";

const { Title, Link } = Typography;
const { Option } = Select;

function LabCatalog(props) {
  const updateCategorySuccessMessage = useSelector(
    (state) => state.catalogReducer.updateCategorySuccessMessage
  );

  const [modalVisible, setModalVisible] = useState(false);
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };

  const onAddInsurance = async (payload) => {
    const payloadObj = { abroad_insurance: payload };
    await props.addCatalogAbroadInsurance(payloadObj);
    await props.getAllCatalogAbroadInsurance(undefined, 20, currentPage);
    hideModal();
  };

  const updateCatalogAbroadInsurance = async (payloadObj) => {
    await props.updateCatalogAbroadInsurance(payloadObj);
    await props.getAllCatalogAbroadInsurance(undefined, 20, currentPage);
  };

  const renderData = useCallback(
    (currentPage) => {
      props.getAllCatalogAbroadInsurance(undefined, 20, currentPage);
      props.getAllCountry.call();
    },
    [
      props.getAllCatalogAbroadInsurance,
      updateCategorySuccessMessage,
      props.addAbroadInsurance,
      props.deleteAbroadInsuranceSuccess,
    ]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const columns = [
    {
      title: "Title",
      key: "pic_url",
      dataIndex: "pic_url",
      width: "25%",
      render: (_, columnData) => (
        <Row>
          <Col span={6} className="table-fc-image">
            <Image
              src={
                columnData.pic_url ? columnData.pic_url : DEFAULT_AGENCY_IMAGE
              }
              preview={false}
            />
          </Col>
          <Col span={16} offset={1}>
            <div className="table-fc-name">{columnData.name}</div>
            <div className="table-fc-status">
              {columnData.status ? (
                <span className="activate">Active</span>
              ) : (
                <span className="inActivateNotverified">Blocked</span>
              )}
            </div>
            {columnData.link_url ? (
              <div className="view-details">
                <Link
                  target="_blank"
                  href={`//${columnData.link_url.replace(/^https?:\/\//, "")}`}
                >
                  VIEW LINK
                </Link>
              </div>
            ) : null}
          </Col>
        </Row>
      ),
    },
    {
      title: "DESCRIPTION",
      key: "desc",
      dataIndex: "desc",
      width: "45%",
      render: (_, columnData) => <div>{columnData.desc}</div>,
    },
    {
      title: "Country",
      key: "category",
      render: (_, columnData) => <div>{`${columnData.country}`}</div>,
    },
    {
      title: "MORE",
      key: "actions",
      render: (_, columnData) => (
        <ActionsColumn
          columnData={columnData}
          updateCatalogAbroadInsurance={updateCatalogAbroadInsurance}
          allCountry={props.allCountry}
          getAllCatalogAbroadInsurance={props.getAllCatalogAbroadInsurance}
          deleteCatalogAbroadInsurance={props.deleteCatalogAbroadInsurance}
        />
      ),
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAllCatalogAbroadInsurance(queryString, 20, currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <AbroadInsuranceFormModal
        onSubmit={onAddInsurance}
        onCancel={hideModal}
        visible={modalVisible}
        allCountry={props.allCountry}
        title="Add Insurance"
        submitText="Add Insurance"
        categories={props.getAllCategories}
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Abroad - Insurance
          </Title>
        </Col>
        <Col className="gutter-row" span={5} offset={0}></Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={4} offset={0}>
          <Button onClick={showModal} icon={<PlusOutlined />} type="primary">
            <span style={{ fontWeight: "600" }}>Add Insurance</span>
          </Button>
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Spot Finance providers"
          formItems={[
            {
              key: "q[name_cont]",
              label: "Insurance name",
            },
            {
              key: "q[country_cont]",
              label: "Country",
              Component: (
                <Select placeholder="Select Country" size="large">
                  {(props.allCountry || []).map((val) => (
                    <Option value={val.name} key={val.name}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              ),
            },
            {
              key: "q[status_eq]",
              label: "Status",
              Component: (
                <Select placeholder="Select Status" size="large">
                  <Option>Active</Option>
                  <Option value={false}>Blocked</Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={
          props.allAbroadInsurance ? props.allAbroadInsurance.data : null
        }
        pagination={{
          pageSize: 20,
          total: props.allAbroadInsurance?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="id"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default LabCatalog;
